import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const AbjurationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M46.4 4.5q-.2-.6-1.1-.6c-.6.1-.7.9-.7 1.4l.2 5.2q0 5.3-2.8 9.6a13 13 0 0 1-8 5.4q-2.3.6-2.2-1.7c0-2-.3-13-.6-16.5 0-.8-.6-3.4-1.6-3.4C28.2 3.9 28 7 28 8.2L27.4 24c0 1.6-.4 1.8-1.9 1.6q-1.1 0-2.2-.6c-4.6-1.7-6.8-5.3-7.8-9.8q-1.2-4.7-.3-9.5c.3-1.3-.3-1.7-.8-1.8q-.9 0-1.2.5Q12.5 5.5 12 7q-1.2 4-.5 8.3.6 6.5 5.4 10.8l2.7 2q1.2.6.3 1.6l-1 1c-3 3.6-2.6 10.2 1 13.7q2.6 2.5 6 3.5 2.1.6 2 2.6l.8 5q0 .8.9.9a1 1 0 0 0 1-.8l.8-5.2q0-1.8 1.7-2.3 1.9-.6 3.6-1.6c5-3 8.4-9.5 3.4-16-1.3-1.6-1.3-1.8.4-2.8 4.3-2.7 6.5-6.7 7.7-11.4q1.3-5-.6-9.8zm-18.7 39q-.3 1.5-1.7 1a8 8 0 0 1-4.8-7c-.5-2.7 2.3-5.7 4.6-6.4q1.5-.3 1.6 1v4.3l.3 5.5zm10.4-3.9a9 9 0 0 1-4.6 4.8q-1.6.6-1.7-1l.2-11q0-1.9 1.8-1.3c3.4 1 5.6 5.1 4.3 8.5"
      />
    </BaseSvg>
  );
};

export default AbjurationSvg;
